import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["privacySection", "termsText", "termsLabel", "privacyText", "freelancerCheckbox", "salaryLabel"]

  connect() {
    // Direkter Event-Listener als Fallback
    if (this.hasFreelancerCheckboxTarget) {
      this.freelancerCheckboxTarget.addEventListener('change', () => {
        this.updateDisplay()
      })
      
      // Für Checkboxen: click-Event
      if (this.freelancerCheckboxTarget.type === 'checkbox') {
        this.freelancerCheckboxTarget.addEventListener('click', () => {
          // Kleine Verzögerung, damit der checked-Status aktualisiert ist
          setTimeout(() => {
            this.updateDisplay()
          }, 10)
        })
        
        // Auch auf dem Label lauschen
        const label = this.freelancerCheckboxTarget.closest('label')
        if (label) {
          label.addEventListener('click', () => {
            setTimeout(() => {
              this.updateDisplay()
            }, 10)
          })
        }
      }
    }
    
    // Für Radio-Buttons: Lausche auf alle Radio-Buttons mit demselben Namen
    const radioButtons = this.element.querySelectorAll('input[type="radio"][name*="freelancer"]')
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        this.updateDisplay()
      })
    })
    
    this.updateDisplay()
  }

  toggle() {
    this.updateDisplay()
  }

  updateDisplay() {
    // Unterstütze Checkboxen, Select-Felder und Radio-Buttons
    let isFreelancer = false
    
    // Prüfe zuerst alle Radio-Buttons (wenn vorhanden)
    const radioButtons = this.element.querySelectorAll('input[type="radio"][name*="freelancer"]')
    if (radioButtons.length > 0) {
      radioButtons.forEach(radio => {
        if (radio.checked && (radio.value === 'true' || radio.value === true)) {
          isFreelancer = true
        }
      })
    } else if (this.hasFreelancerCheckboxTarget) {
      // Fallback für Checkboxen und Select-Felder
      if (this.freelancerCheckboxTarget.type === 'checkbox') {
        isFreelancer = this.freelancerCheckboxTarget.checked
      } else if (this.freelancerCheckboxTarget.tagName === 'SELECT') {
        // Für Select-Felder: Wert als String prüfen (true/false oder "true"/"false")
        const value = this.freelancerCheckboxTarget.value
        isFreelancer = value === 'true' || value === true
      }
    }

    if (this.hasPrivacySectionTarget) {
      if (isFreelancer) {
        // Zeige Freelancer-Text
        if (this.hasTermsTextTarget) {
          this.termsTextTarget.innerHTML = this.getFreelancerTermsText()
        }
        if (this.hasTermsLabelTarget) {
          this.termsLabelTarget.textContent = this.getFreelancerTermsLabel()
        }
        if (this.hasPrivacyTextTarget) {
          this.privacyTextTarget.textContent = this.getFreelancerPrivacyText()
        }
        // Zeige Freelancer-Salary-Label
        if (this.hasSalaryLabelTarget) {
          this.salaryLabelTarget.textContent = this.getFreelancerSalaryLabel()
        }
      } else {
        // Zeige Standard-Text
        if (this.hasTermsTextTarget) {
          this.termsTextTarget.innerHTML = this.getStandardTermsText()
        }
        if (this.hasTermsLabelTarget) {
          this.termsLabelTarget.textContent = this.getStandardTermsLabel()
        }
        if (this.hasPrivacyTextTarget) {
          this.privacyTextTarget.textContent = this.getStandardPrivacyText()
        }
        // Zeige Standard-Salary-Label
        if (this.hasSalaryLabelTarget) {
          this.salaryLabelTarget.textContent = this.getStandardSalaryLabel()
        }
      }
    }
  }

  getFreelancerTermsText() {
    // Hole den Freelancer-Text aus dem data-Attribut
    if (this.hasTermsTextTarget) {
      return this.termsTextTarget.getAttribute('data-freelancer-terms-text') || 
             this.termsTextTarget.getAttribute('data-standard-terms-text') ||
             this.termsTextTarget.innerHTML
    }
    return '<a href="/terms">Datenschutzrichtlinie</a>'
  }

  getStandardTermsText() {
    // Hole den Standard-Text aus dem data-Attribut
    if (this.hasTermsTextTarget) {
      return this.termsTextTarget.getAttribute('data-standard-terms-text') || 
             this.termsTextTarget.innerHTML
    }
    return '<a href="/terms">Datenschutzrichtlinie</a>'
  }

  getFreelancerPrivacyText() {
    // Hole den Freelancer-Datenschutztext aus dem data-Attribut
    if (this.hasPrivacyTextTarget) {
      const freelancerText = this.privacyTextTarget.getAttribute('data-freelancer-privacy-text')
      if (freelancerText && freelancerText.trim() !== '') {
        return freelancerText
      }
      // Fallback: Verwende Standard-Text wenn kein Freelancer-Text vorhanden
      return this.getStandardPrivacyText()
    }
    return ''
  }

  getStandardPrivacyText() {
    // Hole den Standard-Datenschutztext aus dem data-Attribut
    if (this.hasPrivacyTextTarget) {
      return this.privacyTextTarget.getAttribute('data-standard-privacy-text') || 
             this.privacyTextTarget.textContent
    }
    return ''
  }

  getFreelancerTermsLabel() {
    // Verwende die Übersetzung für Freelancer aus dem data-Attribut
    if (this.hasTermsLabelTarget) {
      return this.termsLabelTarget.getAttribute('data-freelancer-terms-label') || 
             'Ich akzeptiere die Datenschutzrichtlinie für Freelancer'
    }
    return 'Ich akzeptiere die Datenschutzrichtlinie für Freelancer'
  }

  getStandardTermsLabel() {
    // Verwende die Standard-Übersetzung aus dem data-Attribut
    if (this.hasTermsLabelTarget) {
      return this.termsLabelTarget.getAttribute('data-standard-terms-label') || 
             'Ich akzeptiere die Datenschutzrichtlinie'
    }
    return 'Ich akzeptiere die Datenschutzrichtlinie'
  }

  getFreelancerSalaryLabel() {
    // Hole das Freelancer-Salary-Label aus dem data-Attribut
    if (this.hasSalaryLabelTarget) {
      return this.salaryLabelTarget.getAttribute('data-freelancer-salary-label') || 
             'Stundensatz in €'
    }
    return 'Stundensatz in €'
  }

  getStandardSalaryLabel() {
    // Hole das Standard-Salary-Label aus dem data-Attribut
    if (this.hasSalaryLabelTarget) {
      return this.salaryLabelTarget.getAttribute('data-standard-salary-label') || 
             'Gehaltsvorstellung (brutto/Jahr)'
    }
    return 'Gehaltsvorstellung (brutto/Jahr)'
  }
}
